import router from "./index";

export default [
  {
    path: "/student",
    component: () => import('../views/Student/Student'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "admin")
        router.replace("/home");
      else
        next();
    },
    meta: {
      title: '学生管理'
    },
    children: [{
      path: '/',
      redirect: 'StuList'
    },
      {
        path: 'StuList',
        component: () => import('../views/Student/StuList/StuList'),
        meta: {
          title: '学生列表'
        },
      }, {
        path: 'StuDetail',
        component: () => import('../views/Student/StuDetail/StuDetail'),
        meta: {
          title: '学生详细'
        },
      },
      {
        path: 'AddStudent',
        component: () => import('../views/Student/AddStudent/AddStudent'),
        meta: {
          title: '添加学生'
        },
      },
    ]
  },
]
